var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          staticClass: "bill-dialog",
          attrs: {
            id: "app",
            visible: _vm.innerVisible,
            title:
              _vm.requestSource === "booking"
                ? _vm.$t("CargoMsg.Cargo_DomesticBill")
                : _vm.$t("Message.Bill"),
            fullscreen: !_vm.isBpm,
            width: _vm.isBpm ? "1640px" : "auto",
            "close-on-press-escape": false,
            "modal-append-to-body": false,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.innerVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            {
              style:
                "min-width: 1600px;" +
                (_vm.expandedGrid || !_vm.showBillForm
                  ? "height: 100%;display: flex;flex-direction: column;"
                  : "")
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.expandedGrid,
                      expression: "!expandedGrid"
                    }
                  ],
                  staticClass: "app-main-inner-row bill-dialog-form-wrapper"
                },
                [
                  _vm.showBillForm
                    ? _c("bill-form", {
                        ref: "billForm",
                        attrs: {
                          billing: _vm.billing,
                          "billing-form-params": _vm.billingFormParams,
                          "is-view": _vm.isView,
                          "request-source": _vm.requestSource,
                          "create-bill-way": _vm.createBillWay,
                          accounts: _vm.accounts
                        },
                        on: {
                          calculateAmount: _vm.calculateAmount,
                          currencyChangeEvent: _vm.currencyChangeEvent,
                          accountIdChange: _vm.onAccountIdChange,
                          refreshOtherBillingData: _vm.otherBillingData
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "app-main-inner-row",
                  staticStyle: {
                    "justify-content": "center",
                    "font-size": "30px"
                  }
                },
                [
                  _c("i", {
                    class: _vm.expandedGrid
                      ? "el-icon-caret-bottom"
                      : "el-icon-caret-top",
                    on: {
                      click: function($event) {
                        _vm.expandedGrid = !_vm.expandedGrid
                      }
                    }
                  })
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "app-main-inner-row",
                  staticStyle: { "justify-content": "space-between" }
                },
                [
                  _c(
                    "div",
                    [
                      !_vm.isView
                        ? _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.addBillChargeEvent }
                            },
                            [_vm._v(_vm._s(this.$t("SeaExport.AddBillCharge")))]
                          )
                        : _vm._e(),
                      !_vm.isView
                        ? _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.removeBillChargeEvent }
                            },
                            [
                              _vm._v(
                                _vm._s(this.$t("SeaExport.RemoveBillCharge"))
                              )
                            ]
                          )
                        : _vm._e(),
                      _c(
                        "el-checkbox",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.isView && _vm.chkShowLclVisible,
                              expression: "!isView && chkShowLclVisible"
                            }
                          ],
                          staticStyle: { "margin-left": "10px" },
                          on: { change: _vm.chkChangeHandler },
                          model: {
                            value: _vm.chkShowLclSelected,
                            callback: function($$v) {
                              _vm.chkShowLclSelected = $$v
                            },
                            expression: "chkShowLclSelected"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.ShowLcl")))]
                      ),
                      _vm._l(_vm.instructionBtns, function(item, index) {
                        return [
                          _c(
                            "el-button",
                            {
                              key: index,
                              style: { marginLeft: index === 0 ? "5px" : "" },
                              attrs: {
                                no: item.platformInstructionRuleCode,
                                type: _vm.getInstructionBtnType(item),
                                disabled: !item.allowOperate || _vm.isView
                              },
                              on: {
                                click: function($event) {
                                  return _vm.onInstructionClick(item)
                                }
                              }
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.getInstructionLabel(item)) +
                                  " "
                              )
                            ]
                          )
                        ]
                      })
                    ],
                    2
                  )
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "app-main-inner-row",
                  staticStyle: { "justify-content": "space-between" }
                },
                [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isView,
                          expression: "isView"
                        }
                      ],
                      staticClass: "section"
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          attrs: { no: "reconciliationMode" },
                          on: { change: _vm.reconciliationTypeChangeHandler },
                          model: {
                            value: _vm.reconciliationType,
                            callback: function($$v) {
                              _vm.reconciliationType = $$v
                            },
                            expression: "reconciliationType"
                          }
                        },
                        [
                          _c(
                            "el-radio",
                            { attrs: { no: "viewedByJob", label: "job" } },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("CargoMsg.Cargo_ViewedByJob"))
                              )
                            ]
                          ),
                          _c(
                            "el-radio",
                            {
                              staticStyle: { "margin-right": "10px" },
                              attrs: { no: "viewedByFee", label: "charge" }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("CargoMsg.Cargo_ViewedByFee"))
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "app-main-inner-row row-grid",
                  style:
                    _vm.expandedGrid || !_vm.showBillForm
                      ? "flex-grow: 1;"
                      : "height:300px"
                },
                [
                  _c("cargo-ag-grid", {
                    style: { width: "100%", height: "auto" },
                    attrs: {
                      "config-module":
                        _vm.reconciliationType === "job"
                          ? "1301262"
                          : "1301251",
                      "grid-options": _vm.gridOptions,
                      "column-defs": _vm.columnDefs,
                      "row-data": _vm.rowData
                    },
                    on: {
                      gridReady: function(params) {
                        _vm.gridApi = params.api
                      }
                    }
                  })
                ],
                1
              ),
              _vm.showJoinChargeDialog
                ? _c("join-charge-dialog", {
                    attrs: {
                      visible: _vm.showJoinChargeDialog,
                      "search-item-module": _vm.searchItemModule,
                      "default-conditions": _vm.addChargeCondition
                    },
                    on: {
                      "update:visible": function($event) {
                        _vm.showJoinChargeDialog = $event
                      },
                      addChargeCallBackEvent: _vm.addChargeCallBackEvent
                    }
                  })
                : _vm._e(),
              _vm.showConflictChargeDialog
                ? _c("conflict-charges-dialog", {
                    attrs: {
                      visible: _vm.showConflictChargeDialog,
                      charges: _vm.conflictCharges,
                      "view-source": "billingDetail"
                    },
                    on: {
                      "update:visible": function($event) {
                        _vm.showConflictChargeDialog = $event
                      },
                      conflictChargeCallBackEvent:
                        _vm.conflictChargeCallBackEvent
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          !_vm.isBpm
            ? _c(
                "div",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  _vm.isNew
                    ? _c(
                        "span",
                        {
                          staticStyle: {
                            position: "absolute",
                            left: "0",
                            "padding-left": "10px"
                          }
                        },
                        [
                          _c(
                            "el-checkbox",
                            {
                              attrs: { no: "invoice_sp30" },
                              model: {
                                value: _vm.defaultContent,
                                callback: function($$v) {
                                  _vm.defaultContent = $$v
                                },
                                expression: "defaultContent"
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("Invoice.invoice_sp30")))]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "permission",
                          rawName: "v-permission",
                          value: ["button_InternalBillInfo_invoiceFromBilling"],
                          expression:
                            "['button_InternalBillInfo_invoiceFromBilling']"
                        }
                      ],
                      attrs: {
                        disabled: _vm.applyInvoiceDisabled || _vm.isBpm,
                        type: "primary"
                      },
                      on: {
                        click: function($event) {
                          return _vm.onApplyInvoiceClick(_vm.billing)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("Billing.ApplyForInvoicing")))]
                  ),
                  !_vm.isView
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.saveBilling(false)
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.Save")))]
                      )
                    : _vm._e(),
                  _c(
                    "el-button",
                    {
                      attrs: { disabled: _vm.isBpm },
                      on: {
                        click: function($event) {
                          _vm.innerVisible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.Cancel")))]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.isBpm
            ? _c(
                "template",
                { staticStyle: { height: "65px" }, slot: "footer" },
                [
                  _vm.isBpm
                    ? _c("approval-comments-and-btns", {
                        attrs: {
                          "process-info": _vm.processInfo,
                          records: _vm.records,
                          type: _vm.type,
                          "form-subtype": _vm.MAKE_INVOICE_BILLING.code,
                          "application-dimension":
                            _vm.APPLICATION_DIMENSION_BILL.code,
                          "dashboard-url": _vm.dashboardUrl
                        },
                        on: {
                          close: function($event) {
                            return _vm.$emit("close")
                          },
                          closeAndRefresh: function($event) {
                            return _vm.$emit("closeAndRefresh")
                          }
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            : _vm._e()
        ],
        2
      ),
      _vm.batchCheckingWindow.visible
        ? _c("batch-checking-window", {
            attrs: {
              visible: _vm.batchCheckingWindow.visible,
              lob: _vm.batchCheckingWindow.lob,
              jobs: _vm.batchCheckingWindow.jobs,
              "check-node": _vm.batchCheckingWindow.checkNode,
              "call-back": _vm.batchCheckingWindow.callBack,
              "call-back2": _vm.batchCheckingWindow.callBack2
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.batchCheckingWindow, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _vm.checkingSaveJobWindow.visible
        ? _c("checking-save-job-window", {
            attrs: {
              visible: _vm.checkingSaveJobWindow.visible,
              lob: _vm.checkingSaveJobWindow.lob,
              "row-data": _vm.checkingSaveJobWindow.rowData,
              "check-node": _vm.checkingSaveJobWindow.checkNode,
              "call-back": _vm.checkingSaveJobWindow.callBack
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.checkingSaveJobWindow, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _vm.billEditChargeDialog.visible
        ? _c("bill-edit-charge-dialog", {
            attrs: {
              visible: _vm.billEditChargeDialog.visible,
              title: _vm.billEditChargeDialog.title,
              "simple-jobs": _vm.billEditChargeDialog.simpleJobs,
              job: _vm.job,
              charge: _vm.billEditChargeDialog.charge,
              "currency-list": _vm.billEditChargeDialog.currencyList,
              billing: _vm.billing
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.billEditChargeDialog, "visible", $event)
              },
              callback: _vm.saveBillEditChargeCallback
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }